import React, {useState} from 'react';
import PersonalInfoStyles from '../styles/personalinfor.module.css'

const PersonalInfo = ({ profile, sel_purpose }) => {
    const [firstName, setFirstName] = useState(profile.firstName);
    const [lastName, setLastName] = useState(profile.lastName);
    const [phoneNumber, setPhoneNumber] = useState(profile.phoneNumber);
    const [email, setEmail] = useState(profile.email);
    const [purpose, setPurpose] = useState(sel_purpose);

    const [errors, setErrors] = useState({});

    const validateEmail = (email) => {
        const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return re.test(String(email).toLowerCase());
    };

    const validatePhoneNumber = (phoneNumber) => {
        const re = /^\d{10}$/;
        return re.test(phoneNumber);
    };

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;

        if (!firstName) {
            formIsValid = false;
            errors["firstName"] = "First name cannot be empty";
        }

        if (!lastName) {
            formIsValid = false;
            errors["lastName"] = "Last name cannot be empty";
        }

        if (!phoneNumber) {
            formIsValid = false;
            errors["phoneNumber"] = "Phone number cannot be empty";
        } else if (!validatePhoneNumber(phoneNumber)) {
            formIsValid = false;
            errors["phoneNumber"] = "Phone number is not valid";
        }

        if (!email) {
            formIsValid = false;
            errors["email"] = "Email cannot be empty";
        } else if (!validateEmail(email)) {
            formIsValid = false;
            errors["email"] = "Email is not valid";
        }

        setErrors(errors);
        return formIsValid;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (handleValidation()) {
            alert("Form submitted");
        } else {
            alert("Form has errors.");
        }
    };

    return (

        <div className={PersonalInfoStyles.card}>
            <h2 className={PersonalInfoStyles.title}>Personal Information</h2>
            <div className={PersonalInfoStyles.field}>
                <label className={PersonalInfoStyles.label}>First Name:</label>
                <span className={PersonalInfoStyles.value}>{profile.firstName || "N/A"}</span>
            </div>
            <div className={PersonalInfoStyles.field}>
                <label className={PersonalInfoStyles.label}>Last Name:</label>
                <span className={PersonalInfoStyles.value}>{profile.lastName || "N/A"}</span>
            </div>
            <div className={PersonalInfoStyles.field}>
                <label className={PersonalInfoStyles.label}>Phone Number:</label>
                <span className={PersonalInfoStyles.value}>{profile.phoneNumber || "N/A"}</span>
            </div>
            <div className={PersonalInfoStyles.field}>
                <label className={PersonalInfoStyles.label}>Email:</label>
                <span className={PersonalInfoStyles.value}>{profile.email || "N/A"}</span>
            </div>
            <div className={PersonalInfoStyles.field}>
                <label className={PersonalInfoStyles.label}>Purpose:</label>
                <span className={PersonalInfoStyles.value}>{sel_purpose || "N/A"}</span>
            </div>
            <p className={PersonalInfoStyles.terms}>
                By submitting an authorization, you agree to the Flyzone's
                <a href="/terms-conditions" target="_blank" rel="noopener noreferrer"> <u>Terms and Conditions</u></a>
                and
                <a href="/privacy-policy" target="_blank" rel="noopener noreferrer"> <u>Privacy Policy</u></a>.
            </p>
        </div>
    );
}

export default PersonalInfo;